import { ShaderGradientCanvas, ShaderGradient } from 'shadergradient'
import Typewriter from "./components/Typewriter";
import logo from './logo.png'
import './App.css'

function App() {
  return (
    <div className='App'>
      <ShaderGradientCanvas style={{ position: 'absolute', pointerEvents: 'none' }}>
        <ShaderGradient
          type='waterPlane'
          uStrength={1.4}
          uDensity={1.0}
          cDistance={3.6}
          cAzimuthAngle={180}
          cPolarAngle={90}
          uSpeed={0.3}
          color1='#ff0700'
          color2='#3d9fdb'
          color3='#d0bce1'
          brightness={1.05}
          zoomOut={false}
        />
      </ShaderGradientCanvas>
      <header className='App-header'>
        <img src={logo} className='App-logo' alt='logo' />
        <p className='App-header-desc'>
          <Typewriter text="Make Foundations for the Future." delay={100} delayNextWord={400} delayStartup={2000}/>  
          <span className='cursorBlink'>|</span>
        </p>
      </header>
    </div>
  )
}

export default App
